<template>
  <oscillography-analysis-domain
    :asset="asset"
    :asset-type="assetType"
    :asset-module="assetModule"
    :asset-general-info="assetGeneralInfo"
    :notifications="notifications"
  />
</template>

<script>
import OscillographyAnalysisDomain from '@/domain/components/installation/engineering/oscillographyAnalysis';

export default {
  name: 'OscillographyAnalysisModule',
  components: {
    OscillographyAnalysisDomain,
  },
  props: {
    asset: {
      type: Object,
      default: () => ({}),
    },
    assetType: {
      type: Object,
      default: () => ({}),
    },
    assetModule: {
      type: Object,
      default: () => ({}),
    },
    assetGeneralInfo: {
      type: Object,
      default: () => ({}),
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    if (!this.$hasUserPermission('PER032')) {
      this.$router.replace({
        name: 'engineering',
        params: {
          installationId: this.$route.params.installationId,
        },
      });
    }
  },
};
</script>
